<template>
  <FormContainer v-if="modalitePaiementVisible">
    <template #title>Modalité de paiement</template>
    <template #content>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_53"
          :model-value="moduleEnCours!.avecSubrogation"
          @update:model-value="(value: any) => updateModule('avecSubrogation', activeModuleIndex!, value)"
          label="Paiement direct par l'OPCO à l'organisme de formation"
          :items="OuiOuNon"
          :required="metaModuleEnCours?.avecSubrogation?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.avecSubrogation?.$messageErreurDirty!"
          :readonly
          help="cf. conditions générales AKTO : La délégation de paiement, auprès du prestataire, n’est pas acquise de plein droit. AKTO se réserve, discrétionnairement, le droit d’accepter ou non la délégation de paiement."
          class="col-10 col-md-14 col-sm-36"
        />
      </div>
    </template>
  </FormContainer>

  <FraisFormation
    :frais-data-par-mode
    :readonly
    :nature-frais="store.lov.NatureFrais"
    :modifie-frais
    :msgInformation
    :msgErreur
  ></FraisFormation>
</template>

<script setup lang="ts">
  import { computed, inject } from 'vue'
  import { FormContainer } from '@/features/interface/demande/shared'
  import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore'
  import { OuiOuNon } from '@/features/interface/shared/tools'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { ModuleActionKey, type ModuleAction } from '../../useModuleActions'
  import type { ModuleDTO } from '@/features/api/extranet/dto/Demande/AF'
  import { FraisFormation } from '@/features/interface/demande/shared'
  import { storeToRefs } from 'pinia'
  import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'

  const store = useDemandeAFStore()
  const { moduleEnCours, activeModuleIndex, modifieFrais, readonly, fraisDataParMode, metaModuleEnCours } =
    inject<ModuleAction>(ModuleActionKey)!

  const { setupArrayUpdaterWithKey } = store
  const { model, typeContextCourant } = storeToRefs(store)

  const updateModule = setupArrayUpdaterWithKey<ModuleDTO>('formation.modules')

  const msgInformation = computed(() =>
    model.value?.sousDispositif === 'ActionStandard' || model.value?.sousDispositif === 'PDC'
      ? 'Si vous ne souhaitez pas de remboursement pour les frais pédagogiques , veuillez saisir 0. Cependant, vous devez demander le remboursement d’au moins un autre frais (autres frais pédagogiques, frais annexes ou rémunération).'
      : null,
  )

  const msgErreur = computed(() => {
    return metaModuleEnCours.value && metaModuleEnCours.value.fraisPedagogiques?.$messageErreurDirty
      ? metaModuleEnCours.value.fraisPedagogiques.$messageErreurDirty!
      : null
  })

  const modalitePaiementVisible = computed(() => {
    return (
      moduleEnCours?.value?.typeModule === 'Externe' &&
      typeContextCourant.value === TypesContextesAutorisesEnum.Adherent
    )
  })
</script>
